<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="key" />
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive" :key="key" />
    <!-- <EmailButton /> -->
    <ChatWidget />
  </div>
</template>

<script>
export default {
  components: {
    // EmailButton: () => import("@/components/EmailButton.vue"),
    ChatWidget: () => import("@/components/ChatWidget.vue"),
  },
  computed: {
    key() {
      return this.$route.fullPath;
    },
  },
};
</script>
